// local enable this
// export const API_URL = process.env.NODE_ENV==="development"?"http://10.2.3.133:8000/":"https://api.app.norvichospital.com/_api/";
export const API_URL = "https://api.meraki.dolphin.com.np/_api/";
// export const API_URL = "http://10.2.3.122:8081/";

// live enable this
// export const API_URL = "https://api.meraki.dolphin.com.np/_api";

export default API_URL;
